export enum LinkTarget {
    Modal = 'modal',
    Blank = 'blank',
    Internal = 'internal',
}
